import Repository from "./Repository";

export default {
    fetchCountries() {
        return Repository.get("/course/countries/all");
    },
    fetchStates(country) {
        return country
            ? Repository.get(`/course/${country}/states`)
            : Repository.get("/course/states/all");
    },
    fetchCities(state) {
        return Repository.get(`/city?state=${state}`);
    },
};
